/**
 * Editorial Hero — Intersection Observer Animations
 * Minx Accents | OS 2.0
 */

(function () {
  'use strict';

  function initEditorialHero(section) {
    const animate = section.dataset.animate === 'true';
    const style   = section.dataset.animation || 'fade-up';

    if (!animate || style === 'none') {
      section.querySelectorAll('.eh-anim').forEach(el => el.classList.add('is-visible'));
      return;
    }

    const stagger  = parseInt(section.dataset.stagger, 10) || 120;
    const elements = Array.from(section.querySelectorAll('.eh-anim'))
      .sort((a, b) => (parseInt(a.dataset.order, 10) || 0) - (parseInt(b.dataset.order, 10) || 0));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);

          elements.forEach((el, i) => {
            setTimeout(() => el.classList.add('is-visible'), i * stagger);
          });
        });
      },
      { threshold: 0.15 }
    );

    observer.observe(section);
  }

  function init() {
    document.querySelectorAll('.editorial-hero').forEach(initEditorialHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
